import clsx from "clsx";
import { termsAndConditions } from "../../types/items/TermsAndConditions";
import { useTranslation } from "react-i18next";
import Footer from "src/components/layout/Footer";
import React from "react";
import Loader from "src/components/loaders/Loader";
import { usePageNotFoundStore } from "src/store/layout/usePageNotFoundStore";

export default function TermsAndConditions() {
  const { t, i18n } = useTranslation();

  const language = i18n.language;
  const isRTL = language === "ar";

  const { loading, setLoading } = usePageNotFoundStore();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [setLoading]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <main
        className={clsx("min-h-screen relative z-0", {
          "direction-rtl": isRTL,
        })}
      >
        {/* Hero Section */}

        <div className="max-w-4xl mx-auto text-center mt-20">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            <span className="text-primary">{t("TermsAndConditions")}</span>
          </h1>
        </div>

        <div className="max-w-4xl mx-auto px-4 py-16">
          <div
            className={clsx("bg-white rounded-3xl p-8 shadow-xl border", {
              "text-right": isRTL,
            })}
          >
            {termsAndConditions.map((section, index) => (
              <div key={index} className="space-y-6">
                <h3 className="text-xl font-semibold mb-2">
                  {isRTL ? section.title.ar : section.title.en}
                </h3>
                {section.description && (
                  // هنا التعديل: إضافة الكلاس "whitespace-pre-wrap"
                  <p className="text-gray-600 pb-10 whitespace-pre-wrap">
                    {isRTL ? section.description.ar : section.description.en}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
